module.exports = __webpack_public_path__ + "img/S-WEB-Goal-03.9ae4b682.png";